import React, {Component} from 'react';
import {connect} from 'react-redux';
import CartPropertyDropdownSelection from "./CartPropertyDropdownSelection";
import {getCartSoftware} from "../../selectors/SimpleSelectors";
import {getSoftwareOptions} from "../../selectors/Software";
import {querySelectCartProperty} from "../../actions/Properties";

function mapStateToProps(state) {
    return {
        softwareInCart: getCartSoftware(state),
        softwareOptions: getSoftwareOptions(state),
        cartIsBusy: state.cart && state.cart.isFetching
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectSoftware: (value) => {
            return dispatch(querySelectCartProperty("software", value))
        }
    };
}

class SoftwareSelect extends Component {
    render() {
        if (!this.props.softwareOptions) {
            return null;
        }
        return (
            <CartPropertyDropdownSelection
                propertyOptions={this.props.softwareOptions}
                activeCartProperty={this.props.softwareInCart}
                selectPropertyCallback={this.props.selectSoftware}
                placeHolder="Gewünschte Software zur Vorinstallation wählen"
                selectionSuffix=""
                hideDefaultInclusiveTag={true}
            />
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SoftwareSelect);



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/SoftwareSelect.js
 **/